export const useIsEmailValid = (email: string): boolean => {
  if (
    email === '' ||
    /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
  ) {
    return true
  }
  return false
}
